import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export type PartnerMe = {
  id: number;
  name: string;
  slug: string;
  type: string;
  contact_email: string;
  currency: string;
  country_code: string;
  timezone: string;
  is_active: boolean;
  pricing: { duration_days: number; price_cents: number; effective_from: string }[];
  commission: { commission_pct: string; effective_from: string } | null;
};

export function useCurrentPartner() {
  return useQuery<PartnerMe>({
    queryKey: ["partner", "me"],
    queryFn: async () => (await api.get<PartnerMe>("/partner/me")).data,
    staleTime: 60_000,
  });
}
